import * as ActionConfigurationManager from './config.actions';

export const avsSuccess = ActionConfigurationManager.AVS_SUCCESS
export const avsFailed = ActionConfigurationManager.AVS_FAILED
export const avsReset = ActionConfigurationManager.AVS_RESET
